<template>
  <slot v-if="isEnabled" />
  <slot v-else name="disabled" />
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user';
import { computed } from 'vue';

const props = defineProps<{
  name: string;
}>();

const { hasFeature } = useUserStore();

const isEnabled = computed(() => hasFeature(props.name));
</script>
